export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function requireString(value: unknown, field: string): string {
  if (typeof value !== 'string')
    throw new Error(`Expected a string for "${field}"`)
  return value
}

export function requireNumber(value: unknown, field: string): number {
  if (typeof value !== 'number')
    throw new Error(`Expected a number for "${field}"`)
  return value
}

export function requireBoolean(value: unknown, field: string): boolean {
  if (typeof value !== 'boolean')
    throw new Error(`Expected a boolean for "${field}"`)
  return value
}

export function nullableString(value: unknown, field: string): string | null {
  if (value === null || value === undefined) return null
  if (typeof value !== 'string')
    throw new Error(`Expected a string or null for "${field}"`)
  return value
}

export function nullableNumber(value: unknown, field: string): number | null {
  if (value === null || value === undefined) return null
  if (typeof value !== 'number')
    throw new Error(`Expected a number or null for "${field}"`)
  return value
}

export function nullableBoolean(value: unknown, field: string): boolean | null {
  if (value === null || value === undefined) return null
  if (typeof value !== 'boolean')
    throw new Error(`Expected a boolean or null for "${field}"`)
  return value
}

export function optionalString(
  value: unknown,
  field: string,
): string | undefined {
  if (value === undefined || value === null) return undefined
  if (typeof value !== 'string')
    throw new Error(`Expected a string for "${field}"`)
  return value
}

export function optionalStringArray(
  value: unknown,
  field: string,
): string[] | undefined {
  if (value === undefined || value === null) return undefined
  if (!Array.isArray(value) || value.some((v) => typeof v !== 'string'))
    throw new Error(`Expected an array of strings for "${field}"`)
  return value as string[]
}

export function requireArray<T>(raw: unknown, name: string, decode: (item: unknown) => T): T[] {
  if (!Array.isArray(raw)) throw new Error(`Malformed ${name}`)
  return raw.map(decode)
}

export function requireTimestamp(raw: unknown, name: string): string {
  const value = requireString(raw, name)
  if (!Number.isFinite(Date.parse(value))) throw new Error(`Invalid date-time for "${name}"`)
  return value
}
